var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5303 6.53033C23.8232 6.23743 23.8232 5.76256 23.5303 5.46967L18.7574 0.696698C18.4645 0.403804 17.9896 0.403804 17.6967 0.696698C17.4038 0.989591 17.4038 1.46446 17.6967 1.75736L21.9393 6L17.6967 10.2426C17.4038 10.5355 17.4038 11.0104 17.6967 11.3033C17.9896 11.5962 18.4645 11.5962 18.7574 11.3033L23.5303 6.53033ZM6.55671e-08 6.75L23 6.75L23 5.25L-6.55671e-08 5.25L6.55671e-08 6.75Z",
    fill: "#335FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallarrow);
export default __webpack_public_path__ + "static/media/smallarrow.e83f620277c42207f0e77aa7fb54651e.svg";
export { ForwardRef as ReactComponent };